<template>
	<path d="M12 14a2 2 0 100-4 2 2 0 000 4z" fill="currentColor" />
	<path d="M16.24 7.76a6 6 0 010 8.49M7.76 16.25a6 6 0 010-8.49M19.07 4.93a10 10 0 010 14.14M4.93 19.07a10 10 0 010-14.14"
		fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
</template>
